import Vue from 'vue'

import cookie from 'vux/src/tools/cookie/index.js'

import config from '@/utils/config'
import utils from '@/utils/utils'

const api = {

getHome(data) {
return Vue.http.get('/api/home', {
...data
})
},

gethotdata(data) {
return Vue.http.get('/api/articles', {
...data
})
},

Articledetails(data) {
return Vue.http.get("/api/articles/" + data)
},

graduation() {
return Vue.http.get('/api/graduates')
},

search(data) {
return Vue.http.get('/api/search', {
...data
})
},

getKeywords(data) {
return Vue.http.get('/api/keywords', {
...data
})
},

getSearchOptions(data) {
return Vue.http.get('/api/schools/search_options', {
...data
})
},

getSchoolList(data) {
return Vue.http.get('/api/schools', {
...data
})
},


getSchoolDetail(id) {
return Vue.http.get('/api/schools/'+id,{
id:id
})
},
}

export default api



// WEBPACK FOOTER //
// ./src/utils/api.js